import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { dashboardAPI as apiConfig } from '../../../axiosConfig';

export const getTogglez = createAsyncThunk('togglez', async () => {
  const response = await apiConfig
    .get('/togglz')
    .catch((error) => error && error.response && error.response);

  const data = await { ...response.data };

  return data;
});

export const addTogglez = createAsyncThunk(
  'togglez/add',
  async ({ payload, headers }) => {
    const response = await apiConfig
      .post('/togglz', payload, { headers })
      .catch((error) => error && error.response && error.response);

    const data = await { ...response.data };

    return data;
  },
);

export const updateTogglez = createAsyncThunk(
  'togglez/update',
  async ({ formValues, headers }) => {
    const toggleId = formValues.id;
    const payload = { status: formValues.status };

    const response = await apiConfig.put(`/togglz/${toggleId}`, payload, {
      headers,
    });
    const data = await response.data;

    return data;
  },
);

export const deleteTogglez = createAsyncThunk(
  'togglez/delete',
  async ({ toggleId, headers }) => {
    const response = await apiConfig.delete(`/togglz/${toggleId}`, {
      headers,
    });
    const data = await { ...response.data, id: toggleId };

    return data;
  },
);

const toggleSlice = createSlice({
  name: 'toggles',
  initialState: {
    data: [],
    selectedToggle: {},
  },
  reducers: {
    selectToggle(state, action) {
      const toggleId = action.payload;
      state.selectedToggle = state.data.find(
        (toggles) => toggles.id === toggleId,
      );
    },
  },
  extraReducers: {
    [getTogglez.fulfilled]: (state, action) => {
      if (action.payload.status !== 'OK') {
        state.data = [];
        return;
      }

      if (!action.payload || !action.payload.data) {
        return;
      }

      state.data = [...action.payload.data];
    },
    [addTogglez.fulfilled]: (state, action) => {
      if (action.payload.status !== 'Created') {
        return;
      }

      const newToggle = action.payload.data;
      state.data.push(newToggle);
    },
    [updateTogglez.fulfilled]: (state, action) => {
      if (action.payload.status !== 'OK') {
        return;
      }

      const updatedId = action.payload.data && action.payload.data.id;
      const data = [...state.data];
      const updateIndex = data.findIndex((toggle) => toggle.id === updatedId);

      if (updateIndex !== -1) {
        data[updateIndex] = { ...action.payload.data };
        state.data = [...data];
      }
    },
    [deleteTogglez.fulfilled]: (state, action) => {
      if (action.payload.status !== 'OK') {
        return;
      }

      const data = [...state.data];
      const deletedId = action.payload.id;
      const deletedToggleIndex = data.findIndex(
        (toggle) => toggle.id === deletedId,
      );
      data.splice(deletedToggleIndex, 1);
      state.data = [...data];
    },
  },
});

export const toggleActions = toggleSlice.actions;

export default toggleSlice.reducer;
